//
// Forked from object.js to add types and comments. Implementation likely to drift as time
// goes on. See original:
// https://github.com/observablehq/inspector/blob/e88c0459a71f9bcfd8c22b8c78262f71979821b2/src/object.js
//

const {
	getOwnPropertySymbols,
	prototype: { hasOwnProperty },
} = Object;
const { toStringTag } = Symbol;

export const FORBIDDEN = {};

export const symbolsof = getOwnPropertySymbols;

export type ObjectKey = string | number | symbol;

export const { getPrototypeOf, getOwnPropertyDescriptors } = Object;
export const objectPrototype = getPrototypeOf({});

/**
 * Returns true if an object has a property "as its own" property, i.e., it was not inherited.
 */
export function isown(object: any, key: ObjectKey) {
	return hasOwnProperty.call(object, key);
}

export function tagof(object: any): string {
	return (
		// Custom-provided string value of type used for default implementation of `toString`, e.g.,
		// the `MyObject` in `[object MyObject]`.
		object[toStringTag] ||
		// Name of the constructor used, e.g., `Object`, `Array`, or `String`
		(object.constructor && object.constructor.name) ||
		// Fallback.
		"Object"
	);
}

/**
 * Return the value of `object[key]`, or the `FORBIDDEN` object if accessing the value would raise a
 * SecurityError.
 */
export function valueof(object: any, key: ObjectKey) {
	try {
		const value = object[key];

		if (value) {
			// Attempt to access value; if a SecurityError is thrown, return `FORBIDDEN` instead.
			value.constructor;
		}
		return value;
	} catch (ignore) {
		return FORBIDDEN;
	}
}
